var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarGray = function SvgStarGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9242 4.84863C16.3646 3.95588 17.6362 3.95588 18.0765 4.84863L21.3969 11.5781L21.5717 11.9316L21.9613 11.9883L29.3871 13.0664C30.3703 13.2091 30.765 14.4188 30.0511 15.1152L24.6791 20.3535L24.3969 20.6289L24.4633 21.0176L25.7308 28.4131C25.8985 29.3948 24.8695 30.1414 23.9896 29.6787L17.35 26.1875L17.0013 26.0039L16.6517 26.1875L10.0111 29.6787C9.13106 30.1416 8.1013 29.3947 8.26892 28.4131L9.53748 21.0176L9.60388 20.6289L9.32166 20.3535L3.94861 15.1152C3.23638 14.4216 3.62819 13.2105 4.61365 13.0664L4.61267 13.0654L12.0385 11.9883L12.4291 11.9316L12.6029 11.5781L15.9242 4.84863Z",
    stroke: "#5E5E5E",
    strokeWidth: 1.5
  })));
};
export default SvgStarGray;